import { ServiceAssertionPerformanceComparisonState } from "@idw-types/state/service-assertion-performance-comparison-state";
import { ServiceAssertionPerformanceComparisonActionTypes, ServiceAssertionPerformanceComparisonActions } from "../actions/service-assertion-performance-comparison-actions";
import { TimeRangeTypes } from "@enums/time-range-types";
import { getTimeRange } from "@utils/date-util";

export const initialServiceAssertionPerformanceComparisonState: ServiceAssertionPerformanceComparisonState = {
    referenceData: {
        isLoading: false,
        searchOnPageLoad: false,
        apAssertions: null,
        assertions: null,
        failGreenDiffRange: null,
        failGreenRange: null,
        failRedDiffRange: null,
        failRedRange: null,
        failYellowDiffRange: null,
        failYellowRange: null,
        passGreenDiffRange: null,
        passGreenRange: null,
        passRedDiffRange: null,
        passRedRange: null,
        passYellowDiffRange: null,
        passYellowRange: null,
        policyDecisions: null,
        serviceOfferingMap: null,
        serviceOfferings: null,
        services: null,
        unverifiedGreenDiffRange: null,
        unverifiedGreenRange: null,
        unverifiedRedDiffRange: null,
        unverifiedRedRange: null,
        unverifiedYellowDiffRange: null,
        unverifiedYellowRange: null,
    },
    searchFilters: {
        rpServiceId: null,
        policyDecisions: [],
        version: null,
        serviceOfferingIds: [],
        startDate: getTimeRange(TimeRangeTypes.CURRENT_MONTH).startDate,
        endDate: getTimeRange(TimeRangeTypes.CURRENT_MONTH).endDate,
        timeRangeType: TimeRangeTypes.CURRENT_MONTH
    },
    searchResults: {
        searchDate: null,
        isLoading: false,
        serviceAssertionPerformances: null
    },
};

export const serviceAssertionPerformanceComparisonReducer = (
    state: ServiceAssertionPerformanceComparisonState = initialServiceAssertionPerformanceComparisonState,
    action: ServiceAssertionPerformanceComparisonActions
): ServiceAssertionPerformanceComparisonState => {
    switch (action.type) {
        // Reference Data
        case ServiceAssertionPerformanceComparisonActionTypes.SET_SERVICE_ASSERTION_PERFORMANCE_COMPARISON_REFERENCE_DATA_LOADING:
            return {
                ...state,
                referenceData: {
                    ...(action.payload.isLoading
                        ? { ...initialServiceAssertionPerformanceComparisonState.referenceData }
                        : { ...state.referenceData }),
                    isLoading: action.payload.isLoading
                }
            };
        case ServiceAssertionPerformanceComparisonActionTypes.SET_SERVICE_ASSERTION_PERFORMANCE_COMPARISON_REFERENCE_DATA:
            return {
                ...state,
                referenceData: {
                    ...action.payload.referenceData,
                    isLoading: false
                }
            };
        // Search
        case ServiceAssertionPerformanceComparisonActionTypes.SET_SERVICE_ASSERTION_PERFORMANCE_COMPARISON_SEARCH_FILTERS:
            return {
                ...state,
                searchFilters: {
                    ...action.payload.searchFilters
                }
            };
        case ServiceAssertionPerformanceComparisonActionTypes.SET_SERVICE_ASSERTION_PERFORMANCE_COMPARISON_SEARCH_RESULTS_LOADING:
            return {
                ...state,
                searchResults: {
                    ...(action.payload.isLoading
                        ? { ...initialServiceAssertionPerformanceComparisonState.searchResults }
                        : { ...state.searchResults }),
                    isLoading: action.payload.isLoading
                }
            };
        case ServiceAssertionPerformanceComparisonActionTypes.SET_SERVICE_ASSERTION_PERFORMANCE_COMPARISON_SEARCH_RESULTS:
            return {
                ...state,
                searchResults: {
                    isLoading: false,
                    serviceAssertionPerformances: action.payload.serviceAssertionPerformances,
                    searchDate: new Date()
                }
            };
        default:
            return state;
    }
};